module.exports = __webpack_public_path__ + "static/media/OVER.1e7b98d6.png";